import type { FunctionComponent, ReactElement } from 'react';
import { useCallback } from 'react';

import { useCoreDispatch } from '../../store/CoreStore';
import { toastActions } from '../../store/slices/toast/slice';

import { Toast } from './Toast';
import type { ToastConnectedProps } from './types';

export const ToastConnected: FunctionComponent<ToastConnectedProps> = ({
  message,
  timeStamp,
  ...rest
}): ReactElement | null => {
  const dispatch = useCoreDispatch();

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  return <Toast message={message} onClose={closeFn} {...rest} />;
};
